var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('div',[_vm._v(" Copyright 2020 TrueLife.org. All Rights Reserved. ")]),_c('div',{staticClass:"d-flex"})])])
}]

export { render, staticRenderFns }